export default __webpack_public_path__ + "static/media/scritta.830dda43.png";